// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c55cc5be7742e137","7487":"9446ef42d16468ff"}[chunkId] + ".css";
};